// Mascota reportada. Corresponde a la tabla "mascotas" del Excel.

import { z } from "zod";
import {
  fechaPasada,
  punto,
  reportanteSchema,
  textoLibre,
  TIPO_REPORTE,
} from "./comunes.js";
import {
  COLOR_PELAJE,
  ESTADO_MASCOTA,
  SEXO_MASCOTA,
  TAMANO_MASCOTA,
  TIPO_MASCOTA,
} from "./mascotaOpciones.js";

export {
  COLOR_PELAJE,
  ESTADO_MASCOTA,
  SEXO_MASCOTA,
  TAMANO_MASCOTA,
  TIPO_MASCOTA,
} from "./mascotaOpciones.js";

const camposMascota = {
  // Null a proposito en hallazgos: quien encuentra un perro no sabe como se llama.
  nombreMascota: textoLibre(60).optional(),
  tipoMascota: z.enum(TIPO_MASCOTA),
  sexo: z.enum(SEXO_MASCOTA),
  tamano: z.enum(TAMANO_MASCOTA),
  colorPrincipalPelaje: z.enum(COLOR_PELAJE),
  caracteristicasParticulares: textoLibre(500),
  estadoMascota: z.enum(ESTADO_MASCOTA).optional(),

  perdidoEn: fechaPasada.optional(),
  encontradoEn: fechaPasada.optional(),

  perdido: punto.optional(),
  encontro: punto.optional(),

  // Texto que acompana al pin: la direccion es lo que la gente lee en el feed,
  // las coordenadas son para el mapa. Sanitizados por textoLibre.
  // Ubicacion legible para las tarjetas del listado. La manda el frontend
  // desde addressdetails del geocodificador; el texto largo va aparte.
  ciudad: textoLibre(80).optional(),
  departamento: textoLibre(60).optional(),
  direccionHallazgo: textoLibre(150).optional(),
  puntoReferencia: textoLibre(150).optional(),
};

export const crearMascotaSchema = z
  .object({
    tipo: z.enum(TIPO_REPORTE),
    reportante: reportanteSchema,
    ...camposMascota,
  })
  // strict: una clave que no este declarada aca hace fallar el request entero.
  // Por defecto Zod las descarta en silencio, que tambien frena el mass
  // assignment — pero en silencio. Con strict, un intento de inyectar `estado`
  // o `codigoGestionHash` devuelve 400 y queda registrado, en vez de parecer
  // que funciono.
  .strict()
  .superRefine((valor, ctx) => {
    if (!valor.perdido && !valor.encontro) {
      ctx.addIssue({
        code: "custom",
        path: ["perdido"],
        message: "Indica al menos un lugar: donde se perdio o donde se encontro",
      });
    }
    if (valor.tipo === "ENCONTRADO" && !valor.encontro) {
      ctx.addIssue({
        code: "custom",
        path: ["encontro"],
        message: "Un reporte de mascota encontrada necesita el lugar del hallazgo",
      });
    }
  });

export const editarMascotaSchema = z.object(camposMascota).partial().strict();
